import { store as AT } from './AT';
import { store as CZ } from './CZ';
import { store as HR } from './HR';
import { store as HU } from './HU';
import { store as RO } from './RO';
import { store as SK } from './SK';
import { store as RS } from './RS';

export const storeFeatureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
